export default __webpack_public_path__ + "static/media/assets-games.6d5e3fb7.gif";